module.exports = __webpack_public_path__ + "media/images/flags/4x3/gha-2bbc2039d5121f46f66b72bab672eb42.svg";